import React, { useState, useEffect, useRef } from 'react';
import Header from './layout/Header';
import Nav from './layout/Nav';
import Footer from './layout/Footer';
import { Navigate } from 'react-router-dom';
import { LOGOUT_TIME } from '../../data/constant';
import Alert from '../../feature/Alert';

export default function AdminLayout({ children }) {

  const [isLoggedIn, setIsLoggedIn] = useState(true);
  const containerRef = useRef(null);

  useEffect(() => {
    let timer;
    const resetTimer = () => {
      clearTimeout(timer);
      timer = setTimeout(logoutUser, LOGOUT_TIME);
    };

    const logoutUser = () => {
      setIsLoggedIn(false);
      clearTimeout(timer);
      localStorage.removeItem('token');
      localStorage.removeItem('user_id');
      Alert.success('Logout Success');
    };

    const handleUserActivity = () => {
      resetTimer();
    };

    resetTimer();

    document.addEventListener('mousemove', handleUserActivity);
    document.addEventListener('keydown', handleUserActivity);

    return () => {
      document.removeEventListener('mousemove', handleUserActivity);
      document.removeEventListener('keydown', handleUserActivity);
      clearTimeout(timer);
    };
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        const inputsAndSelectsAndButtons = containerRef.current.querySelectorAll(
          'input:not([disabled]), select, button, textarea'
        );
        const index = Array.from(inputsAndSelectsAndButtons).indexOf(event.target);
        if (index < inputsAndSelectsAndButtons.length - 1) {
          const nextElement = inputsAndSelectsAndButtons[index + 1];
          if (nextElement.tagName === 'SELECT') {
            nextElement.focus();
            nextElement.click();
          } else if (nextElement.tagName === 'BUTTON' && nextElement.classList.contains('auto_click')) {
            nextElement.focus();
            nextElement.click();
          } else {
            nextElement.focus();
          }
        }
      }
    };

    if (containerRef.current) {
      containerRef.current.addEventListener('keydown', handleKeyDown);
    }

    return () => {
      if (containerRef.current) {
        containerRef.current.removeEventListener('keydown', handleKeyDown);
      }
    };
  }, []);

  return (
    <>
      {
        isLoggedIn ? (
          <div className="container-scroller" id="sharad" >
            <Header />
            <div className="container-fluid page-body-wrapper">
              <Nav />
              <div className="main-panel " ref={containerRef} >
                {children}
              </div>
              <Footer />
            </div>
          </div>
        ) : (
          <Navigate to="/login" replace />
        )
      }
    </>
  )
}
